
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11596',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11596",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.446",
  "dashboard-client-types": "static-1.238",
  "data-fetching-client": "static-1.9491",
  "foundations-components": "static-1.7549",
  "foundations-components-legacy": "static-1.574",
  "foundations-theming": "static-1.4225",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7819",
  "hub-http-shared-msw-handlers": "static-1.9506",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11246",
  "I18n": "static-7.1574",
  "jasmine-runner": "static-1.6286",
  "marketplace-storefront-base": "static-1.11656",
  "quartz": "static-1.6752",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16464",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2676",
  "reporting-testing-lib": "static-1.8514",
  "settings-ui-lib": "static-1.12336",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6756",
  "ui-addon-i18n": "static-1.10954",
  "ui-addon-react-router-dom": "static-1.9360",
  "unified-auth": "static-1.232",
  "unified-auth-core-lib": "static-1.513",
  "usage-tracker": "static-1.7148",
  "usage-tracker-core": "static-1.6998",
  "customer-data-property-utils": "static-1.7891",
  "history": "static-4.47",
  "hub-http": "static-1.6034",
  "integrations-lib": "static-1.15458",
  "marketplace-ui-common": "static-1.18985",
  "property-management-iframe": "static-1.12398",
  "quartz-config": "static-1.530",
  "quartz-core": "static-1.5971",
  "quartz-routing": "static-1.182",
  "quick-fetch": "static-1.3748",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4448",
  "ts-schema": "static-1.3917",
  "ui-universal-auth": "static-1.8718",
  "UIComponents": "static-3.8193",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3242",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3029",
  "quartz-webpack": "static-1.2976",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3818",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4650",
  "foundations-theming-specialty": "static-1.1941",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9241",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5186",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1245",
  "ui-fonts": "static-1.508",
  "ui-images": "static-2.1096",
  "bend-plugin-foundations-theming": "static-1.2708",
  "foundations-theming-base": "static-1.3210",
  "stylex": "static-1.27",
  "HeadJS": "static-2.713",
  "hs-test-utils-bend-plugin": "static-1.2930",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4140",
  "ai-components-ui-library": "static-1.8380",
  "ai-rendering-library": "static-1.9343",
  "chirp-fetch": "static-1.1696",
  "connections-embed-lib": "static-1.654",
  "copilot-toolkit": "static-1.10567",
  "laboratory-lib": "static-3.6974",
  "marketplace-embed": "static-1.21510",
  "marketplace-ui-details": "static-1.8881",
  "marketplace-ui-reviews": "static-1.18941",
  "marketplace-ui-tracking": "static-1.13156",
  "sanitize-text": "static-1.7955",
  "ui-addon-video-player": "static-1.8510",
  "usage-tracker-multi": "static-1.5562",
  "usage-tracker-session-replay": "static-1.4834",
  "wootric-nps": "static-1.6798",
  "apollo-link-hub-http": "static-2.4463",
  "immer": "static-1.33",
  "immerable": "static-1.3969",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66581",
  "cssUtils": "static-1.736",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11554",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10023",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10185",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7138",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17518",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4335",
  "foundations-components-test-utils": "static-1.5032",
  "quartz-i18n": "static-1.427",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3545",
  "customer-data-objects": "static-1.7463",
  "property-translator": "static-1.5226",
  "frontend-preferences-client": "static-1.7738",
  "hs-promise-utils": "static-1.5407",
  "hubspot-apollo-client": "static-1.4695",
  "integrations-error-boundary-lib": "static-1.12873",
  "integrations-tracking-lib": "static-1.5402",
  "native-integrations-shared-strings": "static-1.7602",
  "reselect": "static-2.16",
  "sanitize": "static-1.4288",
  "superstore": "static-1.4584",
  "ui-shepherd-react": "static-3.9961",
  "ai-settings-ui-library": "static-1.7481",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4491",
  "immutable-less": "static-1.4468",
  "marketplace-ui-client-types": "static-1.16392",
  "nav-meta": "static-1.28948",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10050",
  "ui-addon-upgrades": "static-9.17679",
  "inbound-db-properties-service-client": "static-1.3688",
  "property-management-common": "static-1.4685",
  "ui-addon-iframeable": "static-1.8859",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.427",
  "quartz-head": "static-1.417",
  "quartz-test": "static-1.427",
  "quartz-tracking": "static-1.131",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2956",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20382",
  "ContentUtils": "static-1.67661",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2301",
  "customer-data-filters-ui": "static-1.38951",
  "customer-data-objects-ui-components": "static-1.12823",
  "customer-data-reference-ui-components": "static-1.12960",
  "embedded-academy-lib": "static-1.13589",
  "ExportDialog": "static-6.10201",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40691",
  "reporting-snowflake": "static-1.55199",
  "reporting-ui-components": "static-2.63852",
  "reporting-visualizations": "static-1.58657",
  "ui-addon-teams": "static-1.21261",
  "magpie-lib": "static-1.5408",
  "magpie-types": "static-1.4868",
  "simple-logging-lib": "static-1.2864",
  "navigation-components": "static-1.17311",
  "ai-studio-lib": "static-1.11036",
  "developer-experience-shared-components": "static-1.10294",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7804",
  "ui-tool-access": "static-1.9959",
  "usage-based-billing-components-lib": "static-1.8041",
  "usage-tracker-anonymous": "static-1.5565",
  "usage-tracker-public": "static-1.6959",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3430",
  "persist-promise": "static-1.3522",
  "reference-resolvers": "static-1.7974",
  "ui-extensibility-client-types": "static-1.3758",
  "hubspot-apollo-cache": "static-1.154",
  "universal-page-editor-lib": "static-1.2813",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2222",
  "merchandise-lib": "static-1.259",
  "atom": "static-1.4883",
  "purchase-motions-components": "static-1.5499",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1365",
  "crm-component-utils": "static-1.38512",
  "crm-properties-common-lib": "static-1.5686",
  "framework-data-schema-resolvers": "static-1.6687",
  "reference-resolvers-lite": "static-1.7908",
  "navigation-messaging": "static-1.6638",
  "hubspotter-http-shared-msw-handlers": "static-1.9504",
  "cms-field-types": "static-1.4620",
  "content-icons-ui": "static-1.2158",
  "conversations-skeleton-state": "static-1.7061",
  "crm-message-bus": "static-1.42405",
  "customer-data-filters-ui-msw-helpers": "static-1.21386",
  "customer-data-ui-utilities": "static-1.9637",
  "FormUrlGenerator": "static-2.4543",
  "framework-builder-read-service-client": "static-1.3846",
  "framework-data-schema-quick-fetch": "static-1.6592",
  "multi-account-reference-resolvers": "static-1.787",
  "onboarding-tours": "static-1.16280",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13090",
  "academy-common-lib": "static-1.13049",
  "content-assistance-lib": "static-1.7468",
  "dashboard-lib": "static-1.80678",
  "file-manager-components": "static-1.22928",
  "getting-started-shared-tasks": "static-1.17923",
  "hubspot-prosemirror": "static-1.17641",
  "hubspot-prosemirror-plugins": "static-1.17633",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19492",
  "share-with-third-party-component-lib": "static-1.8506",
  "ui-addon-draggable": "static-3.4579",
  "ui-asset-management-lib": "static-1.10728",
  "ui-business-units-lib": "static-1.8843",
  "user-context": "static-1.4913",
  "growth-payments-core": "static-1.24764",
  "reporting-plugins": "static-1.10002",
  "reporting-reports": "static-1.66259",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.539",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28880",
  "react-codemirror": "static-1.10441",
  "apps-service-types": "static-1.3691",
  "oauth-service-types": "static-1.4058",
  "onboarding-scopes": "static-1.6277",
  "onboarding-tours-client": "static-1.4494",
  "platform-infra-nav-components": "static-1.7505",
  "subscription-experience-data-types": "static-1.14604",
  "crm-record-cards-service-types": "static-1.3460",
  "location-customization-utils-lib": "static-1.8602",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4327",
  "nav-client-types": "static-1.2171",
  "purchase-motions-api": "static-1.5502",
  "signup-constants": "static-1.18435",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3728",
  "card-properties-lib": "static-1.43561",
  "crm-actions": "static-1.6117",
  "crm-cards-data": "static-1.1237",
  "crm-cards-sdk": "static-1.42959",
  "customer-data-properties": "static-1.50836",
  "customer-data-properties-shared-msw-handlers": "static-1.8833",
  "customer-data-tracking": "static-1.6696",
  "conditional-properties-service-client": "static-1.3636",
  "crm-pipelines-api-client-types": "static-1.3977",
  "multi-currency-client-types": "static-1.3530",
  "external-options-client-types": "static-1.3997",
  "react-dnd-compat": "static-1.4434",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5172",
  "growth-onboarding-confetti": "static-1.2886",
  "growth-onboarding-next-action-utils": "static-1.1324",
  "onboarding-tours-utils": "static-1.346",
  "ui-shepherd-tracker": "static-1.7342",
  "academy-service-client": "static-1.3494",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27978",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8198",
  "video-components-external": "static-1.10608",
  "video-data-lib": "static-1.34266",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8382",
  "payment-link-components": "static-1.22975",
  "ui-addon-emoji-picker": "static-1.9702",
  "EmailSignatureEditor": "static-1.23937",
  "viral-links-lib": "static-1.6849",
  "data-token-picker": "static-1.16063",
  "FileManagerLib": "static-1.38568",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5058",
  "getting-started-shared-tasks-store": "static-1.17041",
  "campaign-roi-lib": "static-1.8313",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.204",
  "eligibility-engine-service-types": "static-1.3009",
  "crm_data": "static-4.91254",
  "crm-links": "static-1.6080",
  "customer-data-sidebar": "static-2.45454",
  "enrichment-properties-lib": "static-1.15079",
  "crm-fe-perf": "static-1.22719",
  "calling-global-api": "static-1.63717",
  "calling-internal-common": "static-1.31108",
  "calling-lifecycle-internal": "static-1.65099",
  "calling-lifecycle-messages": "static-1.57393",
  "commerce-products-lib": "static-1.8897",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.492",
  "inbounddb-objects-service-types": "static-1.4061",
  "meetings-icalendar-utils-lib": "static-1.447",
  "object-builder-ui-client": "static-1.48023",
  "pipeline-validation-client-types": "static-1.3799",
  "property-value-citations": "static-1.1450",
  "pulse": "static-1.327",
  "smart-property-lib": "static-1.5961",
  "tiered-pricing": "static-1.849",
  "ui-addon-form-validation": "static-1.10808",
  "growth-onboarding-next-action-components": "static-1.1352",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6397",
  "content-media-composition-data-lib": "static-1.11507",
  "content-media-compositions": "static-2.15514",
  "media-bridge-lib": "static-1.18586",
  "commerce-tours-lib": "static-1.5739",
  "growth-onboarding-reliability": "static-1.4900",
  "sales-checkout-service-client": "static-1.3482",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21328",
  "sales-email-signature-service-client": "static-1.3658",
  "audio-components": "static-1.5631",
  "FileManagerCore": "static-1.38427",
  "FileManagerImages": "static-1.36079",
  "video-components": "static-1.12611",
  "crm_universal": "static-1.21681",
  "customer-data-email": "static-1.17691",
  "calling-error-reporting": "static-1.31114",
  "card-payment-highlight-lib": "static-1.36537",
  "card-subscription-highlight-lib": "static-1.38894",
  "commerce-billing-lib": "static-1.18537",
  "commerce-contract-lib": "static-1.11244",
  "customer-data-content": "static-1.26895",
  "invoices-highlight-card-lib": "static-1.54072",
  "orders-highlight-card-lib": "static-1.20902",
  "products-highlight-card-lib": "static-1.17181",
  "project-storage": "static-1.4547",
  "quotes-highlight-card-lib": "static-1.71254",
  "breeze-intelligence-kit": "static-1.5340",
  "crm-source-interpretation-lib": "static-1.5144",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9589",
  "policy-lib": "static-1.6600",
  "shared-worker-versioning": "static-1.10852",
  "calling-usage-tracker": "static-1.6354",
  "voice-sms-access-library": "static-1.284",
  "commerce-permissions": "static-1.572",
  "products-iframe-lib": "static-1.7354",
  "products-ui-components-shared-msw-handlers": "static-1.9888",
  "directed-graph": "static-1.750",
  "event-emitter": "static-1.761",
  "react-tinymce": "static-1.54657",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9652",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53783",
  "tinymce-plugins": "static-1.56897",
  "tinymce-themes": "static-1.55753",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4346",
  "video-embed": "static-1.35100",
  "social-insights-client-types": "static-1.21391",
  "sequences-lib": "static-1.7703",
  "ui-gdpr-components": "static-1.10161",
  "commerce-shared-components-lib": "static-1.17957",
  "commerce-subscription-lib": "static-1.36471",
  "commerce-tools-ui-lib": "static-1.9827",
  "utility-belt": "static-1.2354",
  "payments-enrollment-embed-lib": "static-1.22072",
  "products-ui-components": "static-1.39416",
  "quotes-client-types": "static-1.37343",
  "quotes-ui-lib": "static-1.79974",
  "SalesContentIndexUI": "static-3.8924",
  "accounting-integrations-ui-components": "static-1.6744",
  "invoices-ui-lib": "static-1.54088",
  "commerce-products-api": "static-1.1976",
  "SafeStorage": "static-1.4218",
  "invoices-iframe-lib": "static-1.56146",
  "quotes-modal-lib": "static-1.101931",
  "calling-orchestration-schema": "static-1.35061",
  "sales-views-client-types": "static-1.4101",
  "hub-http-contrib": "static-1.2857",
  "interframe": "static-3.4603",
  "tinymce-data": "static-1.39868",
  "ui-addon-sales-email": "static-1.5027",
  "layout-dnd-components": "static-1.12057",
  "layout-dnd-utils": "static-1.11032",
  "ui-brand-identity-lib": "static-1.13948",
  "NamespacedHubStyle": "static-2.8909",
  "outpost": "static-1.4018",
  "sequences-client-types-lib": "static-1.7560",
  "customer-data-associations": "static-1.7152",
  "framework-data-table": "static-2.11444",
  "customer-data-rte": "static-1.32476",
  "cv-backend-services": "static-1.1504",
  "growth-onboarding-empty-states": "static-1.5383",
  "InboxConnectUtils": "static-4.14259",
  "payments-post-enroll-local-storage-lib": "static-1.4925",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7154",
  "commerce-tax-lib": "static-1.331",
  "property-description-translator": "static-1.3672",
  "FireAlarmUi": "static-1.4342",
  "sales-templates-service-types-lib": "static-1.4004",
  "commerce-analytics-service-client": "static-1.3470",
  "totals-ui-components": "static-1.23032",
  "ContentData": "static-1.67736",
  "layout-data-lib": "static-1.9357",
  "deal-intel-decorators": "static-1.1297",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27744",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3650",
  "advanced-menus-core": "static-1.14833",
  "advanced-menus-lib": "static-1.11806",
  "ui-memberships-settings-lib": "static-1.33464",
  "deal-intel-utils": "static-1.1301",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14832",
  "simple-menus-lib": "static-1.16349"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11596",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.446",
  "dashboard-client-types": "/dashboard-client-types/static-1.238",
  "data-fetching-client": "/data-fetching-client/static-1.9491",
  "foundations-components": "/foundations-components/static-1.7549",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.574",
  "foundations-theming": "/foundations-theming/static-1.4225",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7819",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9506",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11246",
  "I18n": "/I18n/static-7.1574",
  "jasmine-runner": "/jasmine-runner/static-1.6286",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11656",
  "quartz": "/quartz/static-1.6752",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16464",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2676",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8514",
  "settings-ui-lib": "/settings-ui-lib/static-1.12336",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6756",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10954",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9360",
  "unified-auth": "/unified-auth/static-1.232",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.513",
  "usage-tracker": "/usage-tracker/static-1.7148",
  "usage-tracker-core": "/usage-tracker-core/static-1.6998",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7891",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6034",
  "integrations-lib": "/integrations-lib/static-1.15458",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18985",
  "property-management-iframe": "/property-management-iframe/static-1.12398",
  "quartz-config": "/quartz-config/static-1.530",
  "quartz-core": "/quartz-core/static-1.5971",
  "quartz-routing": "/quartz-routing/static-1.182",
  "quick-fetch": "/quick-fetch/static-1.3748",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4448",
  "ts-schema": "/ts-schema/static-1.3917",
  "ui-universal-auth": "/ui-universal-auth/static-1.8718",
  "UIComponents": "/UIComponents/static-3.8193",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3242",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3029",
  "quartz-webpack": "/quartz-webpack/static-1.2976",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3818",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4650",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1941",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9241",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5186",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1245",
  "ui-fonts": "/ui-fonts/static-1.508",
  "ui-images": "/ui-images/static-2.1096",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2708",
  "foundations-theming-base": "/foundations-theming-base/static-1.3210",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.713",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2930",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4140",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8380",
  "ai-rendering-library": "/ai-rendering-library/static-1.9343",
  "chirp-fetch": "/chirp-fetch/static-1.1696",
  "connections-embed-lib": "/connections-embed-lib/static-1.654",
  "copilot-toolkit": "/copilot-toolkit/static-1.10567",
  "laboratory-lib": "/laboratory-lib/static-3.6974",
  "marketplace-embed": "/marketplace-embed/static-1.21510",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8881",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18941",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13156",
  "sanitize-text": "/sanitize-text/static-1.7955",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8510",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5562",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4834",
  "wootric-nps": "/wootric-nps/static-1.6798",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4463",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3969",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66581",
  "cssUtils": "/cssUtils/static-1.736",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11554",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10023",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10185",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7138",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17518",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4335",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5032",
  "quartz-i18n": "/quartz-i18n/static-1.427",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3545",
  "customer-data-objects": "/customer-data-objects/static-1.7463",
  "property-translator": "/property-translator/static-1.5226",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7738",
  "hs-promise-utils": "/hs-promise-utils/static-1.5407",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4695",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12873",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5402",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7602",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4288",
  "superstore": "/superstore/static-1.4584",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9961",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7481",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4491",
  "immutable-less": "/immutable-less/static-1.4468",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16392",
  "nav-meta": "/nav-meta/static-1.28948",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10050",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17679",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3688",
  "property-management-common": "/property-management-common/static-1.4685",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8859",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.427",
  "quartz-head": "/quartz-head/static-1.417",
  "quartz-test": "/quartz-test/static-1.427",
  "quartz-tracking": "/quartz-tracking/static-1.131",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20382",
  "ContentUtils": "/ContentUtils/static-1.67661",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2301",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38951",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12823",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12960",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13589",
  "ExportDialog": "/ExportDialog/static-6.10201",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40691",
  "reporting-snowflake": "/reporting-snowflake/static-1.55199",
  "reporting-ui-components": "/reporting-ui-components/static-2.63852",
  "reporting-visualizations": "/reporting-visualizations/static-1.58657",
  "ui-addon-teams": "/ui-addon-teams/static-1.21261",
  "magpie-lib": "/magpie-lib/static-1.5408",
  "magpie-types": "/magpie-types/static-1.4868",
  "simple-logging-lib": "/simple-logging-lib/static-1.2864",
  "navigation-components": "/navigation-components/static-1.17311",
  "ai-studio-lib": "/ai-studio-lib/static-1.11036",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10294",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7804",
  "ui-tool-access": "/ui-tool-access/static-1.9959",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8041",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5565",
  "usage-tracker-public": "/usage-tracker-public/static-1.6959",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3430",
  "persist-promise": "/persist-promise/static-1.3522",
  "reference-resolvers": "/reference-resolvers/static-1.7974",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3758",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.154",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2813",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2222",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "atom": "/atom/static-1.4883",
  "purchase-motions-components": "/purchase-motions-components/static-1.5499",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1365",
  "crm-component-utils": "/crm-component-utils/static-1.38512",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5686",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6687",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7908",
  "navigation-messaging": "/navigation-messaging/static-1.6638",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9504",
  "cms-field-types": "/cms-field-types/static-1.4620",
  "content-icons-ui": "/content-icons-ui/static-1.2158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7061",
  "crm-message-bus": "/crm-message-bus/static-1.42405",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21386",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9637",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4543",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3846",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6592",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.787",
  "onboarding-tours": "/onboarding-tours/static-1.16280",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13090",
  "academy-common-lib": "/academy-common-lib/static-1.13049",
  "content-assistance-lib": "/content-assistance-lib/static-1.7468",
  "dashboard-lib": "/dashboard-lib/static-1.80678",
  "file-manager-components": "/file-manager-components/static-1.22928",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17923",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17641",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17633",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19492",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8506",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4579",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10728",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8843",
  "user-context": "/user-context/static-1.4913",
  "growth-payments-core": "/growth-payments-core/static-1.24764",
  "reporting-plugins": "/reporting-plugins/static-1.10002",
  "reporting-reports": "/reporting-reports/static-1.66259",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.539",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28880",
  "react-codemirror": "/react-codemirror/static-1.10441",
  "apps-service-types": "/apps-service-types/static-1.3691",
  "oauth-service-types": "/oauth-service-types/static-1.4058",
  "onboarding-scopes": "/onboarding-scopes/static-1.6277",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4494",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7505",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14604",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8602",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4327",
  "nav-client-types": "/nav-client-types/static-1.2171",
  "purchase-motions-api": "/purchase-motions-api/static-1.5502",
  "signup-constants": "/signup-constants/static-1.18435",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3728",
  "card-properties-lib": "/card-properties-lib/static-1.43561",
  "crm-actions": "/crm-actions/static-1.6117",
  "crm-cards-data": "/crm-cards-data/static-1.1237",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42959",
  "customer-data-properties": "/customer-data-properties/static-1.50836",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8833",
  "customer-data-tracking": "/customer-data-tracking/static-1.6696",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3636",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3977",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3530",
  "external-options-client-types": "/external-options-client-types/static-1.3997",
  "react-dnd-compat": "/react-dnd-compat/static-1.4434",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5172",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2886",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1324",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.346",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7342",
  "academy-service-client": "/academy-service-client/static-1.3494",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27978",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8198",
  "video-components-external": "/video-components-external/static-1.10608",
  "video-data-lib": "/video-data-lib/static-1.34266",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8382",
  "payment-link-components": "/payment-link-components/static-1.22975",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9702",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23937",
  "viral-links-lib": "/viral-links-lib/static-1.6849",
  "data-token-picker": "/data-token-picker/static-1.16063",
  "FileManagerLib": "/FileManagerLib/static-1.38568",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5058",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17041",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8313",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.204",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3009",
  "crm_data": "/crm_data/static-4.91254",
  "crm-links": "/crm-links/static-1.6080",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45454",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15079",
  "crm-fe-perf": "/crm-fe-perf/static-1.22719",
  "calling-global-api": "/calling-global-api/static-1.63717",
  "calling-internal-common": "/calling-internal-common/static-1.31108",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65099",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57393",
  "commerce-products-lib": "/commerce-products-lib/static-1.8897",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.492",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4061",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.447",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48023",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3799",
  "property-value-citations": "/property-value-citations/static-1.1450",
  "pulse": "/pulse/static-1.327",
  "smart-property-lib": "/smart-property-lib/static-1.5961",
  "tiered-pricing": "/tiered-pricing/static-1.849",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10808",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1352",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6397",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11507",
  "content-media-compositions": "/content-media-compositions/static-2.15514",
  "media-bridge-lib": "/media-bridge-lib/static-1.18586",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5739",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4900",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3482",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21328",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3658",
  "audio-components": "/audio-components/static-1.5631",
  "FileManagerCore": "/FileManagerCore/static-1.38427",
  "FileManagerImages": "/FileManagerImages/static-1.36079",
  "video-components": "/video-components/static-1.12611",
  "crm_universal": "/crm_universal/static-1.21681",
  "customer-data-email": "/customer-data-email/static-1.17691",
  "calling-error-reporting": "/calling-error-reporting/static-1.31114",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36537",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38894",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18537",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11244",
  "customer-data-content": "/customer-data-content/static-1.26895",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54072",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20902",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17181",
  "project-storage": "/project-storage/static-1.4547",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71254",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5340",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5144",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9589",
  "policy-lib": "/policy-lib/static-1.6600",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10852",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6354",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.284",
  "commerce-permissions": "/commerce-permissions/static-1.572",
  "products-iframe-lib": "/products-iframe-lib/static-1.7354",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9888",
  "directed-graph": "/directed-graph/static-1.750",
  "event-emitter": "/event-emitter/static-1.761",
  "react-tinymce": "/react-tinymce/static-1.54657",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9652",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53783",
  "tinymce-plugins": "/tinymce-plugins/static-1.56897",
  "tinymce-themes": "/tinymce-themes/static-1.55753",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4346",
  "video-embed": "/video-embed/static-1.35100",
  "social-insights-client-types": "/social-insights-client-types/static-1.21391",
  "sequences-lib": "/sequences-lib/static-1.7703",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10161",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17957",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36471",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9827",
  "utility-belt": "/utility-belt/static-1.2354",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22072",
  "products-ui-components": "/products-ui-components/static-1.39416",
  "quotes-client-types": "/quotes-client-types/static-1.37343",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79974",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8924",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6744",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54088",
  "commerce-products-api": "/commerce-products-api/static-1.1976",
  "SafeStorage": "/SafeStorage/static-1.4218",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56146",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101931",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35061",
  "sales-views-client-types": "/sales-views-client-types/static-1.4101",
  "hub-http-contrib": "/hub-http-contrib/static-1.2857",
  "interframe": "/interframe/static-3.4603",
  "tinymce-data": "/tinymce-data/static-1.39868",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5027",
  "layout-dnd-components": "/layout-dnd-components/static-1.12057",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11032",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13948",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8909",
  "outpost": "/outpost/static-1.4018",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7560",
  "customer-data-associations": "/customer-data-associations/static-1.7152",
  "framework-data-table": "/framework-data-table/static-2.11444",
  "customer-data-rte": "/customer-data-rte/static-1.32476",
  "cv-backend-services": "/cv-backend-services/static-1.1504",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5383",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14259",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4925",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7154",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.331",
  "property-description-translator": "/property-description-translator/static-1.3672",
  "FireAlarmUi": "/FireAlarmUi/static-1.4342",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4004",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3470",
  "totals-ui-components": "/totals-ui-components/static-1.23032",
  "ContentData": "/ContentData/static-1.67736",
  "layout-data-lib": "/layout-data-lib/static-1.9357",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1297",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27744",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3650",
  "advanced-menus-core": "/advanced-menus-core/static-1.14833",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11806",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33464",
  "deal-intel-utils": "/deal-intel-utils/static-1.1301",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14832",
  "simple-menus-lib": "/simple-menus-lib/static-1.16349"
}
};
